import type { FC, ReactNode } from 'react';
import { isResellerSession } from '../../contexts/ResellerContext';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';

interface IProps {
	children: ReactNode;
}

/**
 * Wrapper component that hides its children from reseller users.
 * Internal users (those with accountId in InternalAccountIds) will see the children.
 * Resellers will see nothing.
 */
export const InternalOnly: FC<IProps> = ({ children }) => {
	const userSession = useAdminUserSession();
	return isResellerSession(userSession) ? null : <>{children}</>;
};
